/**
 * Service worker registration helper.
 *
 *   - Only registers when REACT_APP_ENABLE_SW === 'true' AND in production
 *     AND the runtime supports it.
 *   - Calls onUpdate(registration) when a new version is waiting to activate,
 *     giving the UI a chance to prompt the user to refresh.
 *   - To force-activate a waiting SW from the UI:
 *         registration.waiting.postMessage('SKIP_WAITING');
 *         window.location.reload();
 */
const SW_URL = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

export const registerServiceWorker = ({ onUpdate, onSuccess } = {}) => {
    if (process.env.REACT_APP_ENABLE_SW !== 'true') return;
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register(SW_URL)
            .then((registration) => {
                registration.onupdatefound = () => {
                    const installing = registration.installing;
                    if (!installing) return;
                    installing.onstatechange = () => {
                        if (installing.state !== 'installed') return;
                        if (navigator.serviceWorker.controller) {
                            if (onUpdate) onUpdate(registration);
                        } else if (onSuccess) {
                            onSuccess(registration);
                        }
                    };
                };
            })
            .catch(() => {
                // Registration failures are non-fatal — app keeps working without SW.
            });
    });
};

export const unregisterServiceWorker = () => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.ready
        .then((registration) => registration.unregister())
        .catch(() => {});
};

export default registerServiceWorker;
